export const OPACITY = 0.5;
export const RADIUS = 10;
export const FPS = 16;
export const MC2 = 1;
export const INIT_STATE = {spheres: [], id: 0, timer: null, width: 400, height: 400};




// WEBPACK FOOTER //
// ./src/constants.js